<template>
  <el-container>
    <el-header height="54px" style="padding: 0 10px">
      <el-row>
        <el-col :span="18">
          <el-form :inline="true" :model="formData">
            <el-form-item label="货号">
              <el-input v-model="formData.itemNo" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <!--<el-form-item label="仓库：" >
                            <warehouse-select :value.sync="formData.wID" select_style="width:125px;"></warehouse-select>
                        </el-form-item> -->
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="6" class="operate">
          <el-button type="primary" icon="el-icon-plus" @click="handleAddNew">新增</el-button>
          <el-button type="danger" plain icon="el-icon-delete" @click="handleDelete(null)">删除</el-button>
          <!-- <el-button plain icon="el-icon-download" :loading="loading" @click="handleExport">导出</el-button> -->
          <el-button type="warning" plain icon="el-icon-connection" @click="handOpenSetting">设置</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-table
        stripe
        border
        ref="warningTable"
        row-key="ProductID"
        :data="tableData.items"
        @selection-change="handleSelectionChange"
        v-loading="tableData.loading"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        height="100%"
      >
        <el-table-column type="selection" width="39" />
        <el-table-column prop="ItemNo" label="货号" width="200" />
        <!--<el-table-column prop="WName" label="仓库" />-->
        <el-table-column prop="StockWarningValue" label="预警值" />

        <el-table-column label="操作" width="215" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button plain size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button plain size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer height="45px">
      <el-pagination
        background
        :total="tableData.total"
        :page-size="tableData.pageSize"
        :current-page="tableData.currentPage"
        :page-sizes="[10, 15, 20, 30, 50]"
        layout="prev, pager, next,total, sizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-footer>
    <edit-stock-warning ref="editStockWarningRef" @handleSearch="handleSearch" />
    <el-dialog
      width="500px"
      :title="settingDialog.title"
      :visible="settingDialog.visible"
      @close="settingDialog.visible = false"
      :close-on-click-modal="false"
    >
      <el-form ref="settingForm" label-width="100px" :model="settingDialog.settingForm">
        <el-form-item prop="StockoutWarning" label="库存预警：" v-if="$store.state.routes.systemSetting.WmsEnabled">
          <el-switch v-model="settingDialog.settingForm.StockoutWarning" active-text="启用库存预警" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="settingDialog.visible = false">取 消</el-button>
        <el-button type="primary" v-loading="settingDialog.loading" @click="handleSaveSetting()">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
import { submit, saveSystemSetting } from '@/api/base'
import { requestData } from '@/api/quote'

import EditStockWarning from './components/EditStockWarning.vue'
//import WarehouseSelect from '@/views/components/common/WarehouseSelect.vue'

export default {
  name: 'stockWarning',
  components: {
    //WarehouseSelect,
    EditStockWarning,
  },
  data() {
    return {
      drawerVisible: false,
      currentComponent: 'ComponentA',
      direction: 'rtl',
      loading: false,
      selectRows: [],
      formData: {
        itemNo: '',
        wID: '',
      },
      tableData: {
        loading: false,
        items: [],
        total: 0,
        pageSize: 15,
        currentPage: 1,
      },
      delProductIDs: '',
      settingDialog: {
        loading: false,
        visible: false,
        settingForm: {},
      },
    }
  },
  mounted() {
    const _this = this
    _this.$nextTick(async () => {
      await _this.fetchData()
    })
  },
  methods: {
    async handOpenSetting() {
      var rsp = await submit('/api/stall/getSystemSetting')
      this.settingDialog.settingForm = rsp.data
      this.settingDialog.visible = true
    },
    async handleSaveSetting() {
      var res = await saveSystemSetting({ Json: JSON.stringify(this.settingDialog.settingForm) })
      if (res.success) {
        this.$store.state.routes.systemSetting = res.data
        this.settingDialog.visible = false
      }
    },
    handleClose() {
      this.drawerVisible = false
    },
    //选项发生改变
    handleSelectionChange(selection) {
      this.selectRows = selection
    },
    async fetchData() {
      const _this = this

      _this.tableData.loading = true
      const { data } = await submit('/api/wms/stockWarn/getStockWarningPageList', {
        PageSize: _this.tableData.pageSize,
        CurrentPage: _this.tableData.currentPage,
        ItemNo: _this.formData.itemNo,
        WID: _this.formData.wID,
      }).finally(() => {
        _this.tableData.loading = false
      })

      _this.tableData.total = data.total
      _this.tableData.items = data.datas
    },
    handleSearch() {
      this.fetchData()
    },
    handleAddNew() {
      let postData = {
        ItemNo: '',
        productID: 0,
        pName: '',
        stockWarningValue: '',
        wID: 0,
        wName: '',
        id: 0,
      }
      let that = this
      that.$refs.editStockWarningRef.open(postData)
    },
    handleEdit(row) {
      let postData = {
        itemNo: row.ItemNo,
        productID: row.ProductID,
        pName: row.PName,
        stockWarningValue: row.StockWarningValue,
        wID: row.WID,
        wName: row.WName,
        id: row.ID,
      }
      this.$refs.editStockWarningRef.open(postData)
    },
    handleSetting() {},
    handleDelete(row) {
      var that = this
      if (row == null) {
        if (that.selectRows.length <= 0) {
          that.$baseMessage('请选择要删除的记录', 'error')
          return
        }
        that.$baseConfirm(`您是否要删除选中的 ${that.selectRows.length} 条记录?`, '提示', async () => {
          let ids = that.selectRows.map(x => x.ID)
          that.delProductIDs = ids.join(',')
          that.handleExecute()
        })
      } else {
        that.$baseConfirm(`您是否要删除货品：${row.ItemNo} ?`, '提示', async () => {
          that.delProductIDs = row.ID
          that.handleExecute()
        })
      }
    },
    async handleExecute() {
      var that = this
      await requestData('/api/wms/stockWarn/Delete', {
        iDs: that.delProductIDs,
      }).then(res => {
        if (res.success) {
          that.$message({
            type: 'success',
            message: '删除成功!',
          })
          that.fetchData()
        } else {
          that.$refs.comfirmDelDlg.open(res.msg, that.delProductIDs)
        }
      })
    },
    handleSizeChange(size) {
      this.tableData.pageSize = size
      this.fetchData()
    },
    handleCurrentChange(page) {
      this.tableData.currentPage = page
      this.fetchData()
    },
  },
}
</script>

<style lang="scss" scoped>
.el-header {
  ::v-deep {
    .el-row {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .el-radio-button__inner {
      height: 33px !important;
    }

    .el-form-item {
      margin-bottom: 0 !important;
    }

    .el-input {
      width: 130px !important;
    }

    .el-button {
      height: 33px !important;
    }

    .operate {
      text-align: right;
    }
  }
}
</style>
